import clsx from 'clsx'
import { ClassName } from 'types/props'

import ArrowLeft from '../../../../../assets/arrow.svg?react'
import { PATH } from '../../../../../const'
import { COPY } from '../constants'
import { Link } from '../link'
import classes from './index.module.scss'

export const BackToLoginLink = ({ className }: ClassName) => (
  <Link className={clsx(className, classes.root)} to={PATH.login}>
    <ArrowLeft /> {COPY.backToLogin}
  </Link>
)
